import {styled} from "@mui/material/styles";
import {Box, Button, FormControlLabel} from "@mui/material";
import colors from "../../themes/colors";

export const StyledContainer = styled(Box)({
  fontFamily: 'AvenirNext-Regular',
});

export const StyledQuizTitle = styled(Box)({
  textDecoration: 'underline',
});

export const StyledAnswer = styled(FormControlLabel)({
  border: '2px solid #eee',
  padding: '8px 4px 8px 0',
  margin: '4px 0',
  '&.checked': {
    borderColor: colors.periwinkle,
  },
  '&.correctAnswer': {
    borderColor: colors.green,
  },
});

export const StyledAnswerButton = styled(FormControlLabel)({
  margin: '4px 0',
  textAlign: 'center',
  display: 'block',
});

export const StyledQuestionTitle = styled(Box)({
  '&.wrong': {
    color: colors.redSecond,
  },
  '&.correct': {
    color: colors.green,
  },
});

export const StyledButton = styled(Button)({
  borderWidth: 2,
  borderRadius: 20,
  borderStyle: 'solid',
  '&:hover': {
    borderWidth: 2,
  },
});
